<div class="modal-header">
  <h5 class="modal-title" id="podCodeModalLabel">
    Enter proof‑of‑delivery access code
  </h5>
  <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <input class="form-control"
         placeholder="Enter code"
         [(ngModel)]="code"
         (keyup.enter)="submit()">
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Cancel</button>
  <button class="btn btn-primary"   (click)="submit()">Submit</button>
</div>